// extracted by mini-css-extract-plugin
export var station_craft_preview__bar = "station-craft-preview-module--station_craft_preview__bar--2S5LZ";
export var station_craft_preview__contents = "station-craft-preview-module--station_craft_preview__contents--2tkk4";
export var station_craft_preview__body = "station-craft-preview-module--station_craft_preview__body--2yq2t";
export var station_craft_preview__tz = "station-craft-preview-module--station_craft_preview__tz--1__M0";